"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GlassesIcon = require("./GlassesIcon");
Object.keys(_GlassesIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GlassesIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GlassesIcon[key];
    }
  });
});
var _SettingsIcon = require("./SettingsIcon");
Object.keys(_SettingsIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SettingsIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SettingsIcon[key];
    }
  });
});
